import billingModule from '../../billing.module';
import template from './billingSummary.component.html';
import style from './billingSummary.component.scss';

export default billingModule.component('billingSummary', {
    template,
    style,
    controller(
        asLoadingMask,
        asNotifier,
        billingSubscriptionService,
        billingAccountService,
        textResources,
        billingActionService,
        errorCodeConstants,
        billingPaymentService,
        $q,
        $rootScope,
        billingOverviewEventConstants
    ) {
        let vm = this;

        vm.showAutoPayEnableButton = false;
        vm.autoPayEnableButtonLabel = '';

        vm.$onInit = () => {
            vm.render();

            $rootScope.$on(
                billingOverviewEventConstants.paymentMethodUpdated,
                invalidateRender
            );

            $rootScope.$on(
                billingOverviewEventConstants.upgradeSubscriptionSuccess,
                invalidateRender
            );

            $rootScope.$on(
                billingOverviewEventConstants.makePaymentSuccess,
                invalidateRender
            );
        };

        vm.render = () => {
            asLoadingMask.show();

            $q.all([
                billingAccountService.getBillingAccount().then(
                    data => {
                        if (data) {
                            const account = Object.assign({}, data);

                            vm.billingAccount = data;
                            vm.billingAccount.balance =
                                data.balance >= 0 ? `$${data.balance}` : '';
                            vm.billingAccount.autopay = data.autoPay
                                ? textResources.on
                                : textResources.off;

                            vm.resolvedAccountAndPaymentInfo = {
                                paymentMethod: billingPaymentService.cache,
                                account: account
                            };
                        }
                    },
                    () => {
                        asNotifier.errorAndTryAgain(
                            textResources.billingGetBillingAccountInfo
                        );
                    }
                ),
                billingActionService.getGlobalActions().then(
                    actions => {
                        const createPaymentActionKey = 'payment:create';
                        const enableAutoPayActionKey = 'auto-pay:enable';
                        const zero = 0;
                        const paymentCreateActions = actions.filter(
                            a => a.action === createPaymentActionKey
                        );
                        const enableAutoPayActions = actions.filter(
                            value => value.action === enableAutoPayActionKey
                        );

                        if (paymentCreateActions.length > 0) {
                            vm.createPaymentAction = paymentCreateActions[zero];
                        }

                        if (enableAutoPayActions.length > 0) {
                            vm.showAutoPayEnableButton = true;
                            vm.autoPayEnableButtonLabel =
                                enableAutoPayActions[zero].label;
                        } else {
                            vm.showAutoPayEnableButton = false;
                            vm.autoPayEnableButtonLabel = '';
                        }
                    },
                    () => {
                        asNotifier.errorAndTryAgain(
                            textResources.billingGetActionsFailed
                        );
                    }
                ),
                billingSubscriptionService.getCurrentSubscription().then(
                    data => {
                        if (data) {
                            vm.currentSubscription = data;
                        }
                    },
                    errorResponse => {
                        if (
                            !errorResponse ||
                            !errorResponse.error ||
                            errorResponse.error.code !=
                                errorCodeConstants.forbidden
                        ) {
                            asNotifier.errorAndTryAgain(
                                textResources.billingGetCurrentSubscriptionFailed
                            );
                        }
                    }
                )
            ]).finally(() => {
                asLoadingMask.hide();
            });
        };

        vm.enableAutoPay = () => {
            billingActionService.openModalEnrollAutoPay().then(result => {
                if (result == undefined) {
                    return;
                }

                if (result === false) {
                    asNotifier.error(
                        `${textResources.genericError} ${
                            textResources.ifProblemPersists
                        }`
                    );
                    return;
                }

                invalidateRender();

                asNotifier.success(textResources.billingEnrollAutoPaySuccess);
            });
        };

        vm.paymentFormCallback = (success, result) => {
            if (success) {
                billingPaymentService
                    .updateCurrentPaymentMethod(result.paymentMethodId)
                    .then(
                        () => {
                            invalidateRender();

                            billingActionService.openModalMakePayment(
                                {
                                    account: result.account,
                                    paymentMethod: result.paymentMethod
                                },
                                success => {
                                    if (success) {
                                        invalidateRender();
                                    }
                                }
                            );
                        },
                        () =>
                            asNotifier.error(
                                `${textResources.genericError} ${
                                    textResources.ifProblemPersists
                                }`
                            )
                    );
            }
        };

        function invalidateRender() {
            billingActionService.clearGetGlobalActionsCache();

            vm.render();
        }
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-summary/billingSummary.component.js